import createAction from 'src/redux/utils/createAction';

export const SET_MAKE_CONTENT_SEARCH_REQUEST = 'SET_MAKE_CONTENT_SEARCH_REQUEST';

export const setMakeContentSearchRequest = createAction<() => void>(
  SET_MAKE_CONTENT_SEARCH_REQUEST
);
